import type { RouteRecordRaw } from 'vue-router';

export const knowledgebaseRoute: RouteRecordRaw = {
  path: '/knowledgebase',
  name: 'Knowledgebase',
  component: () => import('./pages/KnowledgebaseLayoutPage.vue'),
  meta: {
    layout: 'main',
    // `:update`, а не `:list`: читати базу знань має право й студент — він
    // робить це в боті, — а цей розділ є її редактором. Веде базу деканат.
    // Та сама межа, яку черга пропозицій нижче провела власним префіксом.
    authorize: ({ isGranted }) => isGranted('ugi:core:knowledgebase-articles:update'),
  },
  children: [
    {
      path: '',
      name: 'KnowledgebaseIndex',
      component: () => import('./pages/KnowledgebaseIndexPage.vue'),
    },
    {
      path: 'proposals',
      name: 'KnowledgebaseProposals',
      component: () => import('./pages/KnowledgebaseProposalsPage.vue'),
      meta: {
        // Черга — не стаття: право читати базу знань має і студент, тому
        // пропозиції стоять на власному наборі прав.
        authorize: ({ isGranted }) => isGranted('ugi:core:knowledgebase-proposals:list'),
      },
    },
    {
      path: 'proposals/:id',
      name: 'KnowledgebaseProposal',
      component: () => import('./pages/KnowledgebaseProposalPage.vue'),
      props: (route) => ({ id: String(route.params['id']) }),
      meta: {
        authorize: ({ isGranted }) => isGranted('ugi:core:knowledgebase-proposals:get'),
      },
    },
    {
      path: 'c/:slug',
      name: 'KnowledgebaseCategory',
      component: () => import('./pages/KnowledgebaseCategoryPage.vue'),
      props: (route) => ({ slug: String(route.params['slug']) }),
    },
    {
      path: 'a/:id',
      name: 'KnowledgebaseArticle',
      component: () => import('./pages/KnowledgebaseArticlePage.vue'),
      props: (route) => ({ id: String(route.params['id']) }),
      // Власного `authorize` немає навмисно — стаття стоїть за гейтом розділу,
      // як і `c/:slug`. `to.meta` — це `Object.assign` по всіх зіставлених
      // записах, тож дочірній маршрут без свого `authorize` успадковує
      // батьківський; той, що був тут раніше, ПЕРЕКРИВАВ його слабшим `:get`.
      // Дублювати те саме право двічі — це другий рядок, який доведеться
      // згадати, коли мінятимуть перший.
    },
    {
      // Історичні посилання виду /knowledgebase/ugikba:… (з чатів, закладок,
      // старих листів). Односегментний шлях не конфліктує з c/, a/ та
      // proposals/ — ті або мають два сегменти, або стоять вище за списком.
      path: ':id',
      redirect: (to) => ({
        name: 'KnowledgebaseArticle',
        params: { id: to.params['id'] },
      }),
    },
  ],
};
